export default __webpack_public_path__ + "static/media/009.0c02978c.jpg";